import { Injectable, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import * as gamesJson from '../../assets/js/games.json';

// Models
import { CountryArray } from '../model/country';
import { PlayerAllData } from '../model/player-all-data';

interface PageContentData {
    [s: string]: string;
}

interface ApiAllData {
    [s: string]: string;
}

interface LoadObj {
    appLoad: boolean;
}

declare let window: any;
declare let jQuery: any;

@Injectable()
export class DataService {
    private pagesData: PageContentData = {};
    private gamesData: any = {};
    private customData: any = {};
    private apiAllData: ApiAllData = {};
    private countryArray: CountryArray[] = [];
    public playerAllData = <PlayerAllData>{};
    public appLoadEmitter: EventEmitter<LoadObj> = new EventEmitter<LoadObj>();
    public pageDataLoadEmitter: EventEmitter<any> = new EventEmitter<any>();
    public loginState: boolean = false;
    public navBottomMenuEmitter: EventEmitter<any> = new EventEmitter();
    public isMobileEmitter: EventEmitter<any> = new EventEmitter();
    public goToLoginFromUrl: any = {};
    public skinName: string = '';
    public countryCurrencyCode: string = '';
    public reloadMyBetCountEvent: EventEmitter<boolean> = new EventEmitter();
    public previousRouter: any = '';
    private contentApiData: any = {};
    private cTempObj: any = {};

    constructor(
        public router: Router,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    // SET & GET Login State
    public loadInitApiData(message: any) {
        let data = JSON.parse(message);
        // console.log('data--', data);
        // set page data
        let pagesData = data.PAGES_DATA;
        pagesData = JSON.parse(pagesData);
        if (isPlatformBrowser(this.platformId)) {
            console.log('pagesData--', pagesData);
        }
        this.setPagesData(pagesData);
        if (data.countryCurrencyCode) {
            this.setCountryCurrencyCode(data.countryCurrencyCode);
        }

        if (pagesData.homePage) {
            let gameData = pagesData.homePage.games || {};
            this.setgamesData(gameData);
        }

        // set skinname
        if (data.skinName) {
            this.setSkinName(data.skinName);
        }

        // set country data
        if (data.COUNTRIES_DATA) {
            let countryData = data.COUNTRIES_DATA;
            countryData = JSON.parse(countryData);
            this.setCountry(countryData);
        }

        this.notifyAppLoad();

        if (data.CUSTOM_DATA) {
            let customData = data.CUSTOM_DATA;
            if (customData) {
                customData = JSON.parse(customData);
                this.setCustomData(customData);
            }
        }

        // // set player data
        // if (data['LOGGED_IN'] === true) {
        //     let playerData: PlayerAllData = JSON.parse(data['FE_PLAYER_BOOLEAN_DATA']);
        //     playerData['playerId'] = data['playerId'];
        //     this.setPlayerAllData(playerData);
        // }
        this.pageDataLoadEmitter.emit(true);
    }

    // SET & GET Login State
    public setLoginState(state: any) {
        this.loginState = state;
    }

    public getLoginState() {
        return this.loginState;
    }

    public notifyAppLoad() {
        let loadApp = {
            appLoad: true
        };
        this.appLoadEmitter.next(loadApp);
    }

    // SET & GET Api All Data
    public setInitApiDataIsAvailable(val: any) {
        this.apiAllData = val;
    }

    public getInitApiDataIsAvailable() {
        return this.apiAllData;
    }

    // SET & GET Country Data
    public setCountry(data: any) {
        this.countryArray = data;
    }

    public getCountry() {
        return this.countryArray;
    }

    public setSkinName(data: any) {
        this.skinName = data;
    }

    public getSkinName() {
        return this.skinName;
    }

    // SET & GET Player All Data
    public setPlayerAllData(arg: PlayerAllData) {
        this.playerAllData = arg;
    }

    public getPlayerAllData(): PlayerAllData {
        return this.playerAllData;
    }

    // SET & GET Pages Data
    setPagesData(arg: any) {
        this.cTempObj = Object.assign({}, this.cTempObj, arg);
        this.pagesData = this.cTempObj;
    }

    getPagesData() {
        return this.pagesData;
    }

    // SET & GET Pages Data
    setCountryCurrencyCode(arg: any) {
        this.countryCurrencyCode = arg;
    }

    getCountryCurrencyCode() {
        return this.countryCurrencyCode;
    }

    // SET & GET Custom Data
    setCustomData(arg: any) {
        this.customData = arg;
    }

    getCustomData() {
        return this.customData;
    }

    setgamesData(arg: any) {
        this.gamesData = arg;
    }

    getgamesData() {
        return this.gamesData;
    }

    getDefaultContentObject() {
        return {
            background: {},
            banner: {},
            digital: {},
            errormsg: {},
            games: {},
            seo: {},
            text: {}
        };
    }

    setGoToLoginFromUrl(arg: any, queryParams: any = null) {
        this.goToLoginFromUrl = {};
        if (queryParams) {
            this.goToLoginFromUrl['queryParam'] = queryParams;
        }
        this.goToLoginFromUrl['url'] = arg;
    }

    getGoToLoginFromUrl() {
        return this.goToLoginFromUrl;
    }

    getAssets(pageName: any): any {
        let pageData = this.getPagesData();
        if (pageData[pageName]) {
            return pageData[pageName];
        }
        return this.getDefaultContentObject();
    }

    public showHideNavBottomMenu(data: any) {
        this.navBottomMenuEmitter.next(data);
    }

    public isMobile(isWindowResize: boolean = false) {
        var width = parseInt(window.innerWidth);
        let isMobile = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent || navigator.vendor) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent || navigator.vendor).substr(0, 4)))
        if ((width <= 1024) || (isMobile == true)) {
            if (isWindowResize) {
                this.isMobileEmitter.emit(true);
            }
            return true;
        } else {
            if (isWindowResize) {
                this.isMobileEmitter.emit(false);
            }
            return false;
        }
    }

    showCommaVal(val: any) {
        var floatVal = parseFloat(val);
        val = floatVal.toFixed(2);
        val = val + '';
        if (isNaN(val)) {
            return '0,00';
        }
        var digSepArray = val.split('.');
        var dig1 = this.humanizeNumber(digSepArray[0]);
        dig1 = dig1.replace(',', '.');
        var dig2 = digSepArray[1];
        var dig = dig1 + ',' + dig2;
        return dig;
    };

    humanizeNumber(n: any) {
        n = n.toString();
        while (true) {
            var n2 = n.replace(/(\d)(\d{3})($|,|\.)/g, '$1,$2$3');
            if (n == n2) { // jshint ignore:line
                break;
            }
            n = n2;
        }
        return n;
    }

    public convertNumberIntoDecimal(val: any, showPointValue: any = 2) {
        if (val === null || val === undefined || val === '') {
            return val;
        }
        val = val.toString();
        if (val.indexOf(".") >= 0) {
            val = val.slice(0, (val.indexOf(".")) + showPointValue + 1);
        } else {
            val = val + '.' + '0'.repeat(showPointValue);
        }
        let digSepArray = val.split('.');
        let dig1 = this.humanizeNumber(digSepArray[0]);
        dig1 = dig1.replace(',', '.');
        let dig = dig1;
        if (digSepArray.length > 1) {
            let dig2 = digSepArray[1].padEnd(showPointValue, '0');
            dig = dig1 + ',' + dig2;
        }
        return dig;
    }

    // SET & GET Active State
    public setPreviousRoute(state: any) {
        this.previousRouter = state;
    }

    public getPreviousRoute() {
        return this.previousRouter;
    }

    setContentApiIsData(data: any) {
        this.contentApiData = data;
    }

    getContentApiIsData() {
        return this.contentApiData;
    }
}
